import { border, Box, Button, Flex, Heading, Image, Text, useBreakpointValue } from '@chakra-ui/react';

import { ActivityCalendar } from 'activity-calendar-react'


import {FaGithub,FaLink} from "react-icons/fa"
// And react-slick as our Carousel Lib
import Slider from 'react-slick';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';


import vs1 from "../Assert/VS1.png"
import vs2 from "../Assert/VS2.png"
import vs3 from "../Assert/VS3.png"
import vs4 from "../Assert/VS4.png"
import vs5 from "../Assert/VS5.png"
import vs6 from "../Assert/VS6.png"
import vs7 from "../Assert/VS7.png"
import vs8 from "../Assert/VS8.png"
import vs9 from "../Assert/VS9.png"
import vs10 from "../Assert/VS10.png"
import vs11 from "../Assert/VS11.png"
import vs12 from "../Assert/VS12.png"
import vs13 from "../Assert/VS13.png"
import vs14 from "../Assert/VS14.png"
import vs15 from "../Assert/VS15.png"



import Bechef1 from "../Assert/BeChef1.png"
import Bechef2 from "../Assert/BeChef2.png"
import Bechef3 from "../Assert/BeChef3.png"
import Bechef4 from "../Assert/BeChef4.png"
import Bechef5 from "../Assert/BeChef5.png"
import Bechef6 from "../Assert/BeChef6.png"
import Bechef7 from "../Assert/BeChef7.png"
import Bechef8 from "../Assert/BeChef8.png"
import Bechef9 from "../Assert/BeChef9.png"
import Bechef10 from "../Assert/BeChef10.png"
import Bechef11 from "../Assert/BeChef11.png"

import blushme1 from "../Assert/blushme1.png"
import blushme2 from "../Assert/blushme2.png"
import blushme3 from "../Assert/blushme3.png"
import blushme4 from "../Assert/blushme4.png"
import blushme5 from "../Assert/blushme5.png"


import ts1 from "../Assert/TS1.png"
import ts2 from "../Assert/TS2.png"
import ts3 from "../Assert/TS3.png"
import ts4 from "../Assert/TS4.png"
import ts5 from "../Assert/TS5.png"
import ts6 from "../Assert/TS6.png"
import ts7 from "../Assert/TS7.png"
import ts8 from "../Assert/TS8.png"
import ts9 from "../Assert/TS9.png"


import rodan1 from "../Assert/R&F1.png"
import rodan2 from "../Assert/R&F2.png"
import rodan3 from "../Assert/R&F3.png"
import rodan4 from "../Assert/R&F4.png"
import rodan5 from "../Assert/R&F5.png"
import rodan6 from "../Assert/R&F6.png"


import Quiz1 from "../Assert/Quiz1.png"
import Quiz2 from "../Assert/Quiz2.png"
import Quiz3 from "../Assert/Quiz3.png"
import Quiz4 from "../Assert/Quiz4.png"
import Quiz5 from "../Assert/Quiz5.png"
import Quiz6 from "../Assert/Quiz6.png"


import { useState } from 'react';

import "./Project.css"
import GitHubCalendar from 'react-github-calendar';

const Projects = () => {
    
  //first carousal
  const [slider, setSlider] = useState('');


const blushmeImg = [blushme1,blushme2,blushme3,blushme4,blushme5];

const travelSphereImg = [ts1,ts2,ts3,ts4,ts5,ts6,ts7,ts8,ts9];

const rodanfeildsImg = [rodan1,rodan2,rodan3,rodan4,rodan5,rodan6];

const quizImg = [Quiz1,Quiz2,Quiz3,Quiz4,Quiz5,Quiz6];

const vsImg = [vs1,vs2,vs3,vs4,vs5,vs6,vs7,vs8,vs9,vs10,vs11,vs12,vs13,vs14,vs15]

const BeChefImg = [Bechef1,Bechef2,Bechef3,Bechef4,Bechef5,Bechef6,Bechef7,Bechef8,Bechef9,Bechef10,Bechef11]

// Settings for the slider first

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,
    arrows: false,
   
    fade: true,
    responsive: [
      {
        breakpoint: 1024,
        settingCarousal: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settingCarousal: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 480,
        settingCarousal: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <>
     <hr className='hrClass' style={{
      height:5,
      backgroundColor:'#29242a'
    }}/>
    <div id='projects' className='projects' >
      <Box color={'white'}>
          <Box>
              <Heading textDecoration={'underline'} fontSize={50} textUnderlineOffset='10px' textDecorationStyle={'solid'} textDecorationColor={'orange'} color={'#15110D'}>Projects </Heading><br/>
          </Box>
          <br/>
        
          <Flex flexDirection={'column'} gap={10}>

            {/* Virtual shop */}
            <div className='projectFlex'>
              <Box
                position={'relative'}
                height={'325px'}
                width={'80%'}
                // flex={10}
                overflow={'hidden'}>
                {/* CSS files for react-slick */}
                <link
                  rel="stylesheet"
                  type="text/css"
                  charSet="UTF-8"
                  href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css"
                />
                <link
                  rel="stylesheet"
                  type="text/css"
                  href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css"
                />
              
                {/* Slider */}
                <Slider className='slider' {...settings} ref={(slider) => setSlider(slider)}>
                  {vsImg.map((url, index) => (
                    <Box
                      className='imagebox'
                      key={index}
                      height={'xs'}
                      borderRadius='20px'
                      position="relative"
                      backgroundPosition="center"
                      backgroundRepeat="no-repeat"
                      backgroundSize="cover"
                      backgroundImage={`url(${url})`
                    }
                    />
                  ))}
                </Slider>
              </Box>
              
              <Box flex={3} display='flex' flexDirection={'column'} gap={2}>
                    <Heading>Virtual Shop</Heading>
                    <Text as={'h2'} color={'orange'}>The website inspired by Industrybuying.com</Text>
                    {/* details */}
                    <Text fontSize={20} textAlign='left'>A website to purchase various products.User can added data,wishlist and order product.<br/>
                    <Text as={'span'} color={'orange'}>Features :</Text> <br/>
                        -Authentication with login and registration.Google authentication.
                        -Product details with similar product data. 
                        -Cart functionality to show the product.
                        -Payment functionality.<br/>
                        -Developed Routes
                        -Admin panel from where users all details to be visible 
                    </Text>
                    {/* Techstack */}
                    <Box fontSize={20} textAlign='left'  justifyContent='center' alignItems={'center'}>
                        <Text as={'span'} color={'orange'}>Tech Stacks :</Text>

                        <div className="flexTech">
                        <div className='techstack'>
                        <Box display={'flex'} flexDirection='column' alignItems={'center'}>
                            <Image 
                            h={'35px'} 
                            src='https://skillicons.dev/icons?i=react' alt='react'/>
                            <Text  fontSize={15}>React</Text>
                        </Box>
                        <Box display={'flex'} flexDirection='column' alignItems={'center'}>
                            <Image h={'35px'}  borderRadius={10}  src='https://e7.pngegg.com/pngimages/72/936/png-clipart-sass-cascading-style-sheets-preprocessor-less-postcss-meng-miscellaneous-text-thumbnail.png' alt='saas'/>
                            <Text  fontSize={15}>Saas</Text>
                        </Box>
                        <Box display={'flex'} flexDirection='column' alignItems={'center'}>
                          <Image h={'35px'} src='https://upload.wikimedia.org/wikipedia/commons/6/62/CSS3_logo.svg' alt='css'/>
                          <Text fontSize={15}>CSS</Text>
                        </Box>
                      
                        <Box display={'flex'} flexDirection='column' alignItems={'center'}>
                            <Image h={'35px'} src='https://skillicons.dev/icons?i=js' alt='JS'/>
                            <Text  fontSize={15}>JavaScript</Text>
                        </Box>
                        <Box display={'flex'} flexDirection='column' alignItems={'center'}>
                            <Image h={'35px'}  borderRadius={10} src='https://img.stackshare.io/service/12421/rzylUjaf_400x400.jpg' alt='chakraUI'/>
                            <Text fontSize={15}>ChakraUi</Text>
                        </Box>
                        </div>
                        <div  className='techstack'>
                        <a href='https://github.com/kiranwankhade/Virtual-Shop' target = '_blank' rel="noreferrer"><Button background="orange" fontWeight={'bold'} color={'black'}  _hover={{color:'white'}} gap={3}><Text as={'span'}><FaGithub/></Text> Github</Button>
                        </a>
                        <a href='https://minishop-nine.vercel.app/' target = '_blank' rel="noreferrer"><Button background="orange" fontWeight={'bold'} color={'black'}  _hover={{color:'white'}} gap={3}><Text as={'span'}><FaLink/></Text> Deploy</Button></a>
                        </div>
                        </div>

                    </Box>
                    {/* Buttons */}
                    
              </Box>
            </div>

             {/* Be Chef */}
             <div className='projectFlex'>
              <Box
                position={'relative'}
                height={'325px'}
                width={'80%'}
                // flex={10}
                overflow={'hidden'}>
                {/* CSS files for react-slick */}
                <link
                  rel="stylesheet"
                  type="text/css"
                  charSet="UTF-8"
                  href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css"
                />
                <link
                  rel="stylesheet"
                  type="text/css"
                  href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css"
                />
              
                {/* Slider */}
                <Slider className='slider' {...settings} ref={(slider) => setSlider(slider)}>
                  {BeChefImg.map((url, index) => (
                    <Box
                      className='imagebox'
                      key={index}
                      height={'xs'}
                      borderRadius='20px'
                      position="relative"
                      backgroundPosition="center"
                      backgroundRepeat="no-repeat"
                      backgroundSize="cover"
                      backgroundImage={`url(${url})`
                    }
                    />
                  ))}
                </Slider>
              </Box>
              
              <Box flex={3} display='flex' flexDirection={'column'} gap={2}>
                    <Heading>BeChef.com</Heading>
                    <Text as={'h2'} color={'orange'}>The website inspired by blueapron.com</Text>
                    {/* details */}
                    <Text fontSize={20} textAlign='left'>A website to purchase various Food Products As per Category.User can added product to the basket, order food.<br/>
                    <Text as={'span'} color={'orange'}>Features :</Text> <br/>
                        -Authentication with login and registration.Google authentication.
                        -Food details with similar Food data. 
                        -Cart functionality to show the product.
                        -Payment functionality.<br/>
                        -Developed Routes
                        -Admin panel create using Mongo DB
                    </Text>
                    {/* Techstack */}
                    <Box fontSize={20} textAlign='left'  justifyContent='center' alignItems={'center'}>
                        <Text as={'span'} color={'orange'}>Tech Stacks :</Text>

                        <div className="flexTech">
                        <div className='techstack'>
                        <Box display={'flex'} flexDirection='column' alignItems={'center'}>
                            <Image 
                            h={'35px'} 
                            src='https://skillicons.dev/icons?i=react' alt='react'/>
                            <Text  fontSize={15}>React</Text>
                        </Box>
                        <Box display={'flex'} flexDirection='column' alignItems={'center'}>
                            <Image h={'35px'}  borderRadius={10}  src='https://skillicons.dev/icons?i=mongodb' alt='saas'/>
                            <Text  fontSize={15}>MongoDB</Text>
                        </Box>
                        <Box display={'flex'} flexDirection='column' alignItems={'center'}>
                          <Image h={'35px'} src='https://upload.wikimedia.org/wikipedia/commons/6/62/CSS3_logo.svg' alt='css'/>
                          <Text fontSize={15}>CSS</Text>
                        </Box>
                      
                        <Box display={'flex'} flexDirection='column' alignItems={'center'}>
                            <Image h={'35px'} src='https://skillicons.dev/icons?i=js' alt='JS'/>
                            <Text  fontSize={15}>JavaScript</Text>
                        </Box>
                        <Box display={'flex'} flexDirection='column' alignItems={'center'}>
                            <Image h={'35px'}  borderRadius={10} src='https://img.stackshare.io/service/12421/rzylUjaf_400x400.jpg' alt='chakraUI'/>
                            <Text fontSize={15}>ChakraUi</Text>
                        </Box>
                        </div>
                        <div className='techstack'>
                        <a href='https://github.com/kiranwankhade/BeChef-Website' target = '_blank' rel="noreferrer"><Button background="orange" fontWeight={'bold'} color={'black'}  _hover={{color:'white'}} gap={3}><Text as={'span'}><FaGithub/></Text> Github</Button>
                        </a>
                        <a href='https://befchef.netlify.app/' target = '_blank' rel="noreferrer"><Button background="orange" fontWeight={'bold'} color={'black'}  _hover={{color:'white'}} gap={3}><Text as={'span'}><FaLink/></Text> Deploy</Button></a>
                        </div>
                      </div>
                    </Box>
                    
              </Box>
            </div>

            {/* BLUSHME */}
            <div  className='projectFlex' >
                <Box
                position={'relative'}
                height={'325px'}
                width={'full'}
                flex={10}
                overflow={'hidden'}>
                {/* CSS files for react-slick */}
                <link
                  rel="stylesheet"
                  type="text/css"
                  charSet="UTF-8"
                  href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css"
                />
                <link
                  rel="stylesheet"
                  type="text/css"
                  href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css"
                />
                {/* Slider */}
                <Slider className='slider' {...settings} ref={(slider) => setSlider(slider)}>
                  {blushmeImg.map((url, index) => (
                    <Box
                      className='imagebox'
                      key={index}
                      height={'xs'}
                      borderRadius='20px'
                      position="relative"
                      backgroundPosition="center"
                      backgroundRepeat="no-repeat"
                      backgroundSize="cover"
                      backgroundImage={`url(${url})`}
                    />
                  ))}
                </Slider>
                </Box>
                <Box flex={6} display='flex' flexDirection={'column'} gap={2}>
                    <Heading>BlushMe.com</Heading>
                    <Text as={'h2'} color={'orange'}>The website inspired by SugarCosmetics.com.</Text>
                    {/* details */}
                    <Text fontSize={20} textAlign='left'>A website to purchase cosmetics products. <br/>
                    <Text as={'span'} color={'orange'}>Features :</Text> <br/>
                        -Authentication with login and registration <br/>
                        -Cart functionality to show the product. <br/>
                        -Payment functionality redirects to OTP  <br/>
                        -Developed Routes
                    </Text>
                    {/* Techstack */}
                    <Box fontSize={20} textAlign='left'  justifyContent='center' alignItems={'center'}>
                        <Text as={'span'} color={'orange'}>Tech Stacks :</Text>

                        <div className="flexTech">
                        <div className='techstack'>
                        <Box display={'flex'} flexDirection='column' alignItems={'center'}>
                            <Image h={'35px'}  src='https://skillicons.dev/icons?i=react' alt='react'/>
                            <Text  fontSize={15}>React</Text>
                        </Box>
                        <Box display={'flex'} flexDirection='column' alignItems={'center'}>
                            <Image h={'35px'} src='https://skillicons.dev/icons?i=js' alt='JS'/>
                            <Text  fontSize={15}>JavaScript</Text>
                        </Box>
                        <Box display={'flex'} flexDirection='column' alignItems={'center'}>
                            <Image h={'35px'}  borderRadius={10} src='https://img.stackshare.io/service/12421/rzylUjaf_400x400.jpg' alt='chakraUI'/>
                            <Text fontSize={15}>ChakraUi</Text>
                        </Box>
                        </div>
                        <div className='techstack'>
                        <a href='https://github.com/kiranwankhade/BlushMe.com' target = '_blank' rel="noreferrer"><Button fontWeight={'bold'} background="orange" color={'black'} _hover={{color:'white'}} gap={3}><Text as={'span'}><FaGithub/></Text> Github</Button>
                        </a>
                        <a href='https://blush-me-com-kiranwankhade.vercel.app/' target = '_blank' rel="noreferrer"><Button background="orange" fontWeight={'bold'} color={'black'}  _hover={{color:'white'}} gap={3}><Text as={'span'}><FaLink/></Text> Deploy</Button></a>
                        </div>
                        </div>
                    </Box>
                    {/* Buttons */}
                    
                </Box>
            </div>



             {/* QUIZ APP */}
             <div  className='projectFlex' >
                <Box
                position={'relative'}
                height={'325px'}
                width={'full'}
                flex={10}
                overflow={'hidden'}>
                {/* CSS files for react-slick */}
                <link
                  rel="stylesheet"
                  type="text/css"
                  charSet="UTF-8"
                  href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css"
                />
                <link
                  rel="stylesheet"
                  type="text/css"
                  href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css"
                />
                {/* Slider */}
                <Slider className='slider' {...settings} ref={(slider) => setSlider(slider)}>
                  {quizImg.map((url, index) => (
                    <Box
                      className='imagebox'
                      key={index}
                      height={'xs'}
                      borderRadius='20px'
                      position="relative"
                      backgroundPosition="center"
                      backgroundRepeat="no-repeat"
                      backgroundSize="cover"
                      backgroundImage={`url(${url})`}
                    />
                  ))}
                </Slider>
                </Box>
                <Box flex={6} display='flex' flexDirection={'column'} gap={2}>
                    <Heading>Quiz App</Heading>
                    <Text as={'h2'} color={'orange'}>The Quiz app inspired by from learning website</Text>
                    {/* details */}
                    <Text fontSize={20} textAlign='left'>A Quiz App where user got the questions and he can give the answers.<br/>
                    <Text as={'span'} color={'orange'}>Features :</Text> <br/>
                        -Start the Quiz.<br/>
                        -Give Answer of the questions. <br/>
                        -If the answer is correct user got the score.<br/>
                        -After 10 questions Quiz again get started. 
                    </Text>
                    {/* Techstack */}
                    <Box fontSize={20} textAlign='left'  justifyContent='center' alignItems={'center'}>
                        <Text as={'span'} color={'orange'}>Tech Stacks :</Text>

                        <div className="flexTech">
                        <div className='techstack'>
                        <Box display={'flex'} flexDirection='column' alignItems={'center'}>
                            <Image h={'35px'}  src='https://skillicons.dev/icons?i=react' alt='react'/>
                            <Text  fontSize={15}>React</Text>
                        </Box>
                        <Box display={'flex'} flexDirection='column' alignItems={'center'}>
                            <Image h={'35px'} src='https://skillicons.dev/icons?i=ts' alt='JS'/>
                            <Text  fontSize={15}>TypeScript</Text>
                        </Box>
                        <Box display={'flex'} flexDirection='column' alignItems={'center'}>
                            <Image h={'35px'}  borderRadius={10} src='https://skillicons.dev/icons?i=css' alt='CSS'/>
                            <Text fontSize={15}>CSS</Text>
                        </Box>
                        </div>
                        <div className='techstack'>
                        <a href='https://github.com/kiranwankhade/QuizApp' target = '_blank' rel="noreferrer"><Button fontWeight={'bold'} background="orange" color={'black'} _hover={{color:'white'}} gap={3}><Text as={'span'}><FaGithub/></Text> Github</Button>
                        </a>
                        <a href='https://my-typescript-quiz-app.netlify.app/' target = '_blank' rel="noreferrer"><Button background="orange" fontWeight={'bold'} color={'black'}  _hover={{color:'white'}} gap={3}><Text as={'span'}><FaLink/></Text> Deploy</Button></a>
                        </div>
                        </div>
                    </Box>
                    {/* Buttons */}
                    
                </Box>
            </div>

            {/* TRAVEL SPHERE */}

            <div className='projectFlex' >
                <Box
                position={'relative'}
                height={'325px'}
                width={'full'}
                flex={10}
                overflow={'hidden'}>
                {/* CSS files for react-slick */}
                <link
                  rel="stylesheet"
                  type="text/css"
                  charSet="UTF-8"
                  href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css"
                />
                <link
                  rel="stylesheet"
                  type="text/css"
                  href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css"
                />
            
                {/* Slider */}
                <Slider className='slider' {...settings} ref={(slider) => setSlider(slider)}>
                  {travelSphereImg.map((url, index) => (
                    <Box
                      className='imagebox'
                      key={index}
                      height={'xs'}
                      position="relative"
                      borderRadius='20px'
                      backgroundPosition="center"
                      backgroundRepeat="no-repeat"
                      backgroundSize="cover"
                      backgroundImage={`url(${url})`}
                    />
                  ))}
                </Slider>
                </Box>
                <Box flex={6} display='flex' flexDirection={'column'} gap={2}>
                    <Heading>Travel Sphere</Heading>
                    <Text as={'h2'} color={'orange'}>The website inspired by Orbitz.com.</Text>
                    {/* details */}
                    <Text fontSize={20} textAlign='left'>A Website use to book hotels while travel<br/>
                    <Text as={'span'} color={'orange'}>Features :</Text> <br/>
                        -Authentication with login and registration <br/>
                        -Details of each hotels <br/>
                        -Cart functionality to show the details. <br/>
                        -Payment functionality redirects to OTP  <br/>
                    </Text>
                    {/* Techstack */}
                    <Box fontSize={20} textAlign='left'  justifyContent='center' alignItems={'center'}>
                        <Text as={'span'} color={'orange'}>Tech Stacks :</Text>

                        <div className="flexTech">
                        <div className='techstack'>
                          <Box display={'flex'} flexDirection='column' alignItems={'center'} >
                            <Image h={'35px'} src='https://skillicons.dev/icons?i=html' alt='html'/>
                            <Text  fontSize={15}>HTML</Text>
                          </Box>

                          <Box display={'flex'} flexDirection='column' alignItems={'center'}>
                            <Image h={'35px'}  src='https://skillicons.dev/icons?i=css' alt='css'/>
                            <Text fontSize={15}>CSS</Text>
                          </Box >

                          <Box display={'flex'} flexDirection='column' alignItems={'center'}>
                            <Image h={'35px'} src='https://skillicons.dev/icons?i=js' alt='JS'/>
                            <Text  fontSize={15}>JavaScript</Text>
                          </Box>
                        </div>
                        <div className='techstack'>
                          <a href='https://github.com/kiranwankhade/Travelsphere' target = '_blank' rel="noreferrer"><Button fontWeight={'bold'} background="orange" color={'black'} _hover={{color:'white'}} gap={3}><Text as={'span'}><FaGithub/></Text> Github</Button></a>
                            <a href='https://graceful-paprenjak-0954c1.netlify.app/' target = '_blank' rel="noreferrer"><Button background="orange" fontWeight={'bold'} color={'black'}  _hover={{color:'white'}} gap={3}><Text as={'span'}><FaLink/></Text> Deploy</Button></a>
                          </div>
                        </div><br/>
                    </Box>
                  
                </Box>
          
            </div>

            {/* RODAN AND FIELDS */}
            {/* <div className='projectFlex'>
                <Box
                position={'relative'}
                height={'325px'}
                width={'full'}
                flex={10}
                overflow={'hidden'}>
                <link
                  rel="stylesheet"
                  type="text/css"
                  charSet="UTF-8"
                  href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css"
                />
                <link
                  rel="stylesheet"
                  type="text/css"
                  href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css"
                />
              
                
                <Slider className='slider' {...settings} ref={(slider) => setSlider(slider)}>
                  {rodanfeildsImg.map((url, index) => (
                    <Box
                      className='imagebox'
                      key={index}
                      height={'xs'}
                      position="relative"
                      backgroundPosition="center"
                      backgroundRepeat="no-repeat"
                      backgroundSize="cover"
                      borderRadius={'20px'}
                      backgroundImage={`url(${url})`}
                    />
                  ))}
                </Slider>
                </Box>
                <Box flex={6} display='flex' flexDirection={'column'} gap={2}>
                    <Heading>RODAN & FIELDS</Heading>
                    <Text as={'h2'} color={'orange'}>The website inspired by Rodan&Feilds.com.</Text>
                    
                    <Text fontSize={20} textAlign='left'>A website for cosmetics products <br/>
                    <Text as={'span'} color={'orange'}>Features :</Text> <br/>
                        -Cart functionality to show the product. <br/>
                        -Developed Pages <br/>
                        -QA section having collapse question answers
                    </Text>
                    <Box fontSize={20} textAlign='left'  justifyContent='center' alignItems={'center'}>
                        <Text as={'span'} color={'orange'}>Tech Stacks :</Text>

                        <div className="flexTech">
                        <div className='techstack'>
                          <Box  display={'flex'} flexDirection='column' alignItems={'center'}>
                            <Image  h={'35px'}  src='https://skillicons.dev/icons?i=html' alt='html'/>
                            <Text  fontSize={15}>HTML</Text>
                          </Box>
                          <Box  display={'flex'} flexDirection='column' alignItems={'center'}>
                            <Image  h={'35px'}  src='https://skillicons.dev/icons?i=js' alt='JS'/>
                            <Text  fontSize={15}>JavaScript</Text>
                          </Box>
                        </div>
                        <div className='techstack'>
                          <a href='https://github.com/kiranwankhade/Rodan-Feilds.com' target = '_blank' rel="noreferrer"><Button fontWeight={'bold'} background="orange" color={'black'} _hover={{color:'white'}} gap={3}><Text as={'span'}><FaGithub/></Text> Github</Button></a>

                          <a href='https://luxury-pixie-30587a.netlify.app/' target = '_blank' rel="noreferrer"><Button background="orange" fontWeight={'bold'} color={'black'}  _hover={{color:'white'}} gap={3}><Text as={'span'}><FaLink/></Text> Deploy</Button></a>
                          </div>
                        </div>
                          <br/>
                    </Box>
                  
                </Box>
            </div> */}

          </Flex>

          <Box  mt={5}>
            <div id="stats"> 
              <Heading textDecoration={'underline'} fontSize={50} textUnderlineOffset='10px' textDecorationStyle={'solid'} textDecorationColor={'orange'} color={'#15110D'}>GitHub Statistic </Heading><br/><br/>
              <div id='statsFlex'>
                <div id='stats Div'>
                  <h1 className='statsName'>GitHub Stats </h1>
                  <img src="https://github-readme-stats.vercel.app/api?username=kiranwankhade&show_icons=true&count_private=true&theme=gruvbox&bg_color=0,000000,130F40&layout=compact&border_radius=10" alt="" />
                </div><br/>

                <div id='contributionDiv'>
                  <h1 className='statsName'>GitHub Contribution </h1>
                  <img src="https://github-readme-streak-stats.herokuapp.com/?user=kiranwankhade&count_private=true&show_icons=true&custom_title=Github&theme=dark&bg_color=0,000000,130F40&layout=compact&border_radius=8&bg" alt="" />
                </div><br/>
              </div><br/>
            <div id="calenderDiv">
             <Heading id='calenderName'  fontSize={40} color={'#15110D'}>My GitHub Calender </Heading><br/>
             <link
                rel="stylesheet"
                href="https://unpkg.com/github-calendar@latest/dist/github-calendar-responsive.css"
              />
             
             <div style={{backgroundColor:'Background',padding:'10px', height:'100%' ,borderRadius:'10px' ,border:"10px solid #3b3228"}}>
              <img id='calenderImg' src="https://ghchart.rshah.org/fa8b00/kiranwankhade" alt="2016rshah's Github chart" />
             </div>
             
            </div> <br/>

            {/* <div id="graphDiv">
              <Heading fontSize={40} color={'#15110D'}>My GitHub Graph </Heading><br/>
              <img src="https://github-readme-activity-graph.cyclic.app/graph?username=kiranwankhade&theme=gruvbox&hide_border=false&layout=compact&border_radius=8" alt="" />
            </div><br/> */}
            </div>
          </Box>
      </Box><br/><br/>
    </div>
    </>
  )
}



export default Projects;